import { UseFormRegisterReturn } from 'react-hook-form';

/** 属性定義 */
type Props = {
  name: string;
  id: string;
  className?: string;
  defaultValue?: string;
  autoComplete?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
  register?: UseFormRegisterReturn;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtMailBox = ({
  name,
  id,
  className,
  defaultValue,
  autoComplete,
  placeholder,
  disabled,
  maxLength,
  minLength,
  register
}: Props) => {
  return <input type='email' className={`atmailbox ${className}`} name={name} id={id} defaultValue={defaultValue} autoComplete={autoComplete} placeholder={placeholder} disabled={disabled} maxLength={maxLength} minLength={minLength} {...register} />;
};
/** 初期値の設定 */
AtMailBox.defaultProps = {
  className: '',
  defaultValue: null,
  autoComplete: null,
  placeholder: null,
  disabled: false,
  maxLength: null,
  minLength: null,
  register: null
};
export default AtMailBox;